const hasWindow = typeof window !== 'undefined';
const hasLocalStorage = hasWindow && typeof window.localStorage !== 'undefined';

export const createWebStorage = (storage = hasLocalStorage ? window.localStorage : undefined) => {
  const safeStorage = storage;

  const setItem = (key, value) => {
    if (!safeStorage) return;
    try {
      const serialized = typeof value === 'string' ? value : JSON.stringify(value);
      safeStorage.setItem(key, serialized);
    } catch {
      // noop
    }
  };

  const getItem = (key) => {
    if (!safeStorage) return null;
    try {
      const raw = safeStorage.getItem(key);
      if (raw === null) return null;
      try {
        return JSON.parse(raw);
      } catch {
        return raw;
      }
    } catch {
      return null;
    }
  };

  const removeItem = (key) => {
    if (!safeStorage) return;
    try {
      safeStorage.removeItem(key);
    } catch {
      // noop
    }
  };

  const clearAuth = () => {
    ['state', 'expires_at', 'authenticated', 'id_token'].forEach((key) => removeItem(key));
  };

  const clearAll = () => {
    if (!safeStorage) return;
    try {
      safeStorage.clear();
    } catch {
      // noop
    }
  };

  return { setItem, getItem, removeItem, clearAuth, clearAll };
};
